import axios from 'axios';
import AzureSearchSearchSettings from './azuresearch.searchsettings';
import AzureSearchRequest from './azuresearch.searchrequest';

export default class AzureSearchApi {
  constructor(settings) {
    this.settings = new AzureSearchSearchSettings();
    if (settings) this.settings = new AzureSearchSearchSettings(settings);

    this.client = axios.create({
      baseURL: `${this.settings.apiSettings.url}/indexes/${this.settings.apiSettings.indexName}/docs`
    });
    this.client.defaults.headers.common['Content-Type'] = 'application/json';
    this.client.defaults.timeout = 0;
    this.client.defaults.method = 'post';

    this.client.interceptors.request.use(
      (config) => {
        config.url =
          config.url +
          '?api-version=' +
          this.settings.apiSettings.apiVersion +
          '&api-key=' +
          this.settings.apiSettings.searchServiceQueryApiKey;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  search(searchRequest) {
    const azureSearchRequest = new AzureSearchRequest(searchRequest);
    return this.client.post(
      '/search',
      azureSearchRequest.getSearchRequestBody()
    );
  }

  suggest(search, suggesterName) {
    return this.client.post('/autocomplete', {
      search,
      suggesterName
    });
  }
}
